import React from "react";

function Messages({ messages, currentMember, drone }) {
  function renderMessage(message) {
    const { member, data, id, clientId } = message;
    console.log(message);
    console.log(member);
    const messageFromMe = drone.clientId === clientId;
    console.log(drone.clientId, clientId, messageFromMe);
    const className = messageFromMe
      ? "Messages-message currentMember"
      : "Messages-message";
    return (
      <li key={id} className={className}>
        <span
          className="avatar"
          style={{ backgroundColor: member.clientData.color }}
        />
        <div className="Message-content">
          <div className="username">{member.clientData.username}</div>
          <div className="text">{data}</div>
        </div>
      </li>
    );
  }
  let i = 1;

  return (
    <ul className="Messages-list">{messages.map((m) => renderMessage(m))}</ul>
  );
}

export default Messages;
